"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.9479 7.27294C25.6749 7.06479 25.341 6.952 24.9977 6.952C24.6545 6.952 24.3208 7.06479 24.0479 7.27294L14.7896 14.3563C14.4606 14.6082 14.245 14.9806 14.1905 15.3914C14.1359 15.8022 14.247 16.2178 14.4989 16.5469C14.7509 16.8759 15.1232 17.0914 15.534 17.1459C15.9448 17.2004 16.3606 17.0895 16.6896 16.8375L23.4352 11.6792V30.9084C23.4352 31.3228 23.6 31.7201 23.893 32.0132C24.186 32.3062 24.5833 32.4709 24.9977 32.4709C25.4121 32.4709 25.8097 32.3062 26.1027 32.0132C26.3958 31.7201 26.5602 31.3228 26.5602 30.9084V11.6833L33.3062 16.8417C33.4691 16.9664 33.6549 17.0579 33.8532 17.1108C34.0514 17.1637 34.2583 17.177 34.4618 17.15C34.6652 17.123 34.8612 17.0563 35.0388 16.9535C35.2164 16.8507 35.372 16.714 35.4968 16.551C35.6216 16.3881 35.713 16.2022 35.7659 16.004C35.8188 15.8057 35.8323 15.5989 35.8053 15.3955C35.7783 15.1921 35.7115 14.996 35.6087 14.8184C35.5059 14.6408 35.369 14.4851 35.2061 14.3604L25.9479 7.27294Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M44.4812 27.9333C44.0668 27.9333 43.6695 28.0979 43.3765 28.391C43.0834 28.684 42.9187 29.0814 42.9187 29.4958V37.3166C42.9176 38.007 42.6429 38.6687 42.1547 39.1569C41.6666 39.645 41.0049 39.9197 40.3145 39.9208H9.68962C8.99912 39.9203 8.3369 39.6458 7.84864 39.1575C7.36039 38.6692 7.086 38.0071 7.08545 37.3166V29.4958C7.08545 29.0814 6.92071 28.684 6.62769 28.391C6.33466 28.0979 5.93735 27.9333 5.52295 27.9333C5.10855 27.9333 4.71098 28.0979 4.41796 28.391C4.12493 28.684 3.96045 29.0814 3.96045 29.4958V37.3166C3.96155 38.8358 4.56549 40.2924 5.63968 41.3666C6.71387 42.4408 8.17049 43.0447 9.68962 43.0458H40.3145C41.8337 43.0447 43.2903 42.4408 44.3645 41.3666C45.4386 40.2924 46.0426 38.8358 46.0437 37.3166V29.4958C46.0437 29.0814 45.8792 28.684 45.5862 28.391C45.2932 28.0979 44.8956 27.9333 44.4812 27.9333Z",
    fill: fill
  }));
};

exports["default"] = _default;